import convertFifteenPlaces from 'components/ProductSideBar/helpers/conversion';
import { Maths } from 'helpers/maths';

const calcUnitPrice = (totalProduct, totalCostValue) => {
  const result = Maths.divide(
    Number.parseFloat(totalCostValue),
    Number.parseFloat(totalProduct)
  );
  if (isFinite(result)) {
    return convertFifteenPlaces(result);
  }
  return typeof result.toNumber === 'function' ? result.toNumber() : result;
};

export default calcUnitPrice;
